import metricsClient from "@/axiosClients/metricsClient";
import metricsResilienceClient from "@/axiosClients/metricsResilienceClient";
import discountCodesClient from "@/axiosClients/discountCodesClient";

const downloadSubsequestSessionsReport = (data) => {
    return metricsClient.post(`/subsequent-sessions/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadInitialSubsequentEvaluationReport = (data) => {
    return metricsClient.post(`/subsequent-initial-answers/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadWaitingListReport = (data) => {
    return metricsClient.post(`/waiting-list/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadWeeklyUsersReport = (data) => {
    return metricsClient.post(`/weekly`, data, {
        responseType: 'blob'
    });
}

const setVideoViewerMetric = (data) => {
    return metricsClient.post(`/upcoming-talks/user/saw-video`, data);
}

const downloadRegisteredUsersReport = (data) => {
    return metricsClient.post(`/users/registered-report`, data, {
        responseType: 'blob'
    });
}

const downloadAllUsersReport = (data) => {
    return metricsClient.post(`/users/all-users-report`, data, {
        responseType: 'blob'
    });
}

const downloadAllSessionsReport = (data) => {
    return metricsClient.post(`/consultations/all-success-report`, data, {
        responseType: 'blob'
    });
}

const downloadConsultationReasonsReport = (data) => {
    return metricsClient.post(`/consultation-reasons/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadPatientsConsultationReasonsReport = (data) => {
    return metricsClient.post(`/patients/consultation-reasons/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadExitQuestions2Report = (data) => {
    return metricsClient.post(`/evaluation-forms/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadEvaluationFormsResilienceReport = (data) => {
    return metricsResilienceClient.post(`/evaluation-forms/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadOpenAnswersResilienceReport = (data) => {
    return metricsResilienceClient.post(`/open-answers/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadTPTTSSReport = (data) => {
    return metricsClient.post(`/tpt/tss/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadTPTTCTReport = (data) => {
    return metricsClient.post(`/tpt/tct/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadTPTTGBReport = (data) => {
    return metricsClient.post(`/tpt/tgb/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadTPTUserInformation = (data) => {
    return metricsClient.post(`/tpt-users/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadGrupoBalintReport = (data) => {
    return metricsClient.post(`/grupo-balint/generate-report`, data, {
        responseType: 'blob'
    });
}

const downloadFechaRespuestaCuestionariosReport = (data) => {
    return metricsClient.post(`/grupo-balint/fecha-respuesta-cuestionarios`, data, {
        responseType: 'blob'
    });
}

export default {
    downloadSubsequestSessionsReport,
    setVideoViewerMetric,
    downloadInitialSubsequentEvaluationReport,
    downloadWaitingListReport,
    downloadWeeklyUsersReport,
    downloadRegisteredUsersReport,
    downloadAllUsersReport,
    downloadAllSessionsReport,
    downloadConsultationReasonsReport,
    downloadPatientsConsultationReasonsReport,
    downloadExitQuestions2Report,
    downloadEvaluationFormsResilienceReport,
    downloadOpenAnswersResilienceReport,
    downloadTPTTSSReport,
    downloadTPTTCTReport,
    downloadTPTTGBReport,
    downloadTPTUserInformation,
    downloadGrupoBalintReport,
    downloadFechaRespuestaCuestionariosReport
}
